import {
    GET_SIMCARD_REQUEST,
    GET_SIMCARD_SUCCESS,
    GET_SIMCARD_FAILURE,
    SET_SIMCARD
} from '../actions/simcards';

const initialState = {
    simcard: {},
    fetching: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_SIMCARD_REQUEST: {
            return {
                ...state,
                fetching: true
            };
        }
        case GET_SIMCARD_SUCCESS: {
            return {
                ...state,
                fetching: false,
                simcard: action.payload.simcard
            };
        }
        case GET_SIMCARD_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        case SET_SIMCARD: {
            return {
                ...state,
                simcard: action.payload.simcard
            };
        }
        default:
            return state;
    }
};
